import { render, staticRenderFns } from "./reporta6.vue?vue&type=template&id=5674adc2&"
import script from "./reporta6.vue?vue&type=script&lang=js&"
export * from "./reporta6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports